import { QueryResolvers } from '@spazious/dollhouse-graphql';

import { ApolloContext } from '../context.js';
import { mapDecoration } from '../helpers/mapDecoration.js';
import { mapFurniture } from '../helpers/mapFurniture.js';

/**
 * Resolver for the virtualObject query.
 */
export const virtualObject: QueryResolvers<ApolloContext>['virtualObject'] = async (
  _,
  variables,
  context
) => {
  const { id } = variables;
  const { api } = context;

  const furnitureResult = await api.diagramming.retrieveDiagrammingVirtualFurnituresId({
    id,
  });
  if (furnitureResult.status === 200) {
    return mapFurniture(furnitureResult.data.data);
  }

  const decorationResult = await api.diagramming.retrieveDiagrammingVirtualObjectsId({
    id,
  });

  if (decorationResult.status === 200) {
    return mapDecoration(decorationResult.data.data);
  }

  throw new Error('Object not found');
};
